<template>
  <v-popup @close="$emit('close')">
    <div v-if="!loading">
      <div class="row pils-popup">
        <div class="p-64 pils-popup__left">
          <div class="mb-10">
            <label class="left-column-label">{{ currentMedKeyTypeName }}</label>
            <div class="left-column-value">
              {{ (item.medKeys || []).join(", ") }}
            </div>
          </div>
          <div class="mb-10">
            <label class="left-column-label">{{ $t("page.order.list.header.medicinename") }}</label>
            <div class="left-column-value">{{ item.medicineName }}</div>
          </div>
          <div class="mb-10">
            <label class="left-column-label">{{ $t("page.order.list.header.manufacturer")}}</label>
            <div class="left-column-value">{{ item.manufacturer }}</div>
          </div>
          <div class="mb-10">
            <label class="left-column-label">UV Sensibility</label>
            <div class="left-column-value">
              {{ $t(item.metadata.uvSensibilityTranslationKey) }}
            </div>
          </div>
          <div class="mb-10">
            <label class="left-column-label">Canister Size</label>
            <div class="left-column-value">
              {{ $t(item.metadata.canisterSizeTranslationKey) }}
            </div>
          </div>
          <div class="mb-40">
            <label class="left-column-label">Pill shape</label>
            <div class="left-column-value">
              {{ $t(item.shape.nameTranslationKey) }}
            </div>
          </div>

          <div class="mb-10">
            <label class="left-column-label">MedID</label>
            <div class="left-column-value">{{ item.metadata.medId }}</div>
          </div>
          <div class="mb-10">
            <label class="left-column-label">Assembly Article Number</label>
            <div class="left-column-value">
              {{ item.metadata.assemblyArticleNumber }}
            </div>
          </div>
          <div class="mb-10">
            <label class="left-column-label">Rotor Article Number</label>
            <div class="left-column-value">
              {{ item.metadata.rotorArticleNumber }}
            </div>
          </div>
        </div>
        <v-pill-shape-form
          hide-tabs
          read-only
          :convex="item.shape.convex"
          :pill="mapShape(item.shape)"
          :pill-form-data="item"
        />
      </div>
    </div>
    <v-loader v-else class="inline" />
    <v-popup-pagination v-bind="$attrs" v-on="$listeners" />
  </v-popup>
</template>

<script>
import { mapGetters } from "vuex";
import { VPopupPagination, VLoader, VPopup } from "shared";
import VPillShapeForm from "@/components/pills/v-pill-shape-form";

import * as WorkListsDAO from "../../dao/worklists-dao";
import * as ShapeUtils from "@/utils/ShapeUtils";

export default {
  components: {
    VPopup,
    VPopupPagination,
    VLoader,
    VPillShapeForm,
  },
  props: {
    listId: {
      type: Number,
      required: true,
    },
    itemId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      item: null,
      loading: true,
    };
  },
  computed: {
    ...mapGetters("medKey", ["currentMedKeyTypeName"]),
  },
  methods: {
    async fetchItem() {
      this.loading = true;
      this.item = await WorkListsDAO.getWorkListItemById(this.listId, this.itemId);
      this.loading = false;
    },
    mapShape: ShapeUtils.mapShape,
  },
  watch: {
    itemId: {
      handler: "fetchItem",
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.left-column-label {
  color: $color-medium-grey;
  font-size: 13px;
  line-height: 16px;
}

.left-column-value {
  font-size: 13px;
  font-weight: bold;
}

.size-box {
  display: inline-block;
  margin-left: 6px;

  & + & {
    margin-left: 6px;
  }
}

.size-label {
  display: block;
  font-size: 13px;
  line-height: 18px;
  color: $color-medium-grey;
  font-weight: bold;
  letter-spacing: 0.433333px;
  margin-bottom: 6px;
}

.size-input {
  max-width: 112px;
  border-radius: 3px;
  height: 40px;
  padding: 0 15px !important;
  font-family: "fsalbertregular";
}

.images-container {
  display: grid;
  grid-template-columns: auto auto;
  grid-auto-rows: 145px;
  text-align: center;
  margin-top: 80px;

  .image-1-of-3 {
    grid-column: 1;
    grid-row: 1;
  }

  .image-2-of-3 {
    grid-column: 1;
    grid-row: 2;
  }

  .image-3-of-3 {
    grid-column: 2;
    grid-row: 2;
  }
}
::v-deep .popup__container {
  .loading-indicator {
    min-height: 600px;
  }
}
.pils-popup {
  margin: 0;
  &__left {
    min-height: 600px;
    width: 29%;
    border-right: 1px solid #ececec;
    padding-top: 165px !important;
    padding-bottom: 55px !important;
    @media all and (max-width: 1200px) {
      padding-left: 30px !important;
      padding-top: 100px !important;
    }
    .mb-10 {
      margin-bottom: 7px;
    }
    .mb-40 {
      margin-bottom: 20px;
    }
  }
  .form-pill__content,
  &__right {
    min-height: 600px;
    margin: 0;
    border: 0;
    width: 71%;
    &::v-deep .form-pill-right {
      width: 100%;
      &__content {
        &--submenu {
          padding-top: 60px;
        }
      }
      &__pills {
        &--groups {
          margin-top: 96px;
        }
      }
    }
  }
}
</style>
